import ReactGA from "react-ga";

let env_check = process.env.NODE_ENV === "production";

let actions = {
  event: options => {
    if (env_check) ReactGA.event(options);
  },
  set: options => {
    if (env_check) ReactGA.set(options);
  },
  pageview: options => {
    if (env_check) ReactGA.pageview(options);
  }
};

export let GA = actions;
